<div class="snack-bar-container" [class.show]="trigger" [class.hide]="!trigger" #sbContainer (mouseover)="still(true)"
     (mouseleave)="still(false)">
    <span *ngIf="show" [innerText]="message | json" class="message"></span>
    <div class="main">
        <span [innerText]="title" class="title"></span>
        <span *ngIf="action" class="details" (click)="showDetail()" [innerText]="action"></span>
    </div>
</div>